import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { editProductPost } from "../repositories/storeRep";




const initialState = {
  response: {},
  loading: false,
  error: false,
  errorMsg: "",
};
export const editProductData= createAsyncThunk(
  "editProduct",
  async (data, thunkAPI) => {
    const response = await editProductPost(data);
    return response;
  }
);
export const editProductSlice = createSlice({
  name: "editProduct",
  initialState,
  extraReducers: {
    [editProductData.pending]: (state) => {
      state.loading = true;
    },
    [editProductData.fulfilled]: (state, action) => {
      state.loading = false;

      state.response = action.payload;
      console.log(action.payload);
    },
    [editProductData.rejected]: (state, action) => {
      state.loading = false;
      state.error = true;
      state.errorMsg = action.error.message;
      console.log(action.error);
    },
  },
  reducers: {},
});

export default editProductSlice.reducer;
